import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
// redux
import { getUsers, updateUserById, deleteUserById, } from 'redux/users/operations';
import { selectUsersList } from 'redux/users/usersSelectors';
// helpers
import { compareStrings, setPageTitle } from 'helpers';
// components
import Modal from 'components/Modal/Modal';
import SubmitMsg from 'components/SubmitMsg/SubmitMsg';
import UsersItem from 'components/UsersList/UsersItem';
import UserEditPswForm from 'components/forms/UserForms/UserEditPswForm';
import UserEditNameForm from 'components/forms/UserForms/UserEditNameForm';
// scss
import './UsersList.scss';

const UsersList = () => {
  const [render, setRender] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [modalType, setModalType] = useState(null);
  const [selectedUserData, setSelectedUserData] = useState(null);
  const usersList = useSelector(selectUsersList);
  const dispatch = useDispatch();
  const submitMsgText = `Ви впевнені, що хочете видалити користувача ?`;

  function onUserChange(data, dataType) {
    let dataToUpd = null;

    switch (dataType) {
      case 'status':
        const { user_id, active } = data ?? {};
        dataToUpd = { active: !active };
        dispatch(updateUserById({ id: user_id, data: dataToUpd }));
        break;
      case 'password':
        setSelectedUserData(data);
        setModal('UserEditPswForm');
        break;
      case 'name':
        setSelectedUserData(data);
        setModal('UserEditNameForm');
        break;
      case 'delete':
        setSelectedUserData(data);
        setModal('UserDeleteModal');
        break;

      default:
        break;
    }
  }

  function setModal(newModalType) {
    if (!newModalType) {
      setModalType(null);
      setShowModal(false);
      return;
    }

    switch (newModalType) {
      case 'UserEditPswForm':
        setModalType('UserEditPswForm');
        break;
      case 'UserEditNameForm':
        setModalType('UserEditNameForm');
        break;
      case 'UserDeleteModal':
        setModalType('UserDeleteModal');
        break;

      default:
        break;
    }

    setShowModal(true);
  }

  function onUserDelete() {
    dispatch(deleteUserById(selectedUserData?.user_id));
    setModal();
  }

  useEffect(() => { setPageTitle("Користувачі") }, []);

  useEffect(() => {
    if (render) return setRender(false);
    dispatch(getUsers());
  }, [render, dispatch]);

  return (
    <>
      <h1 className="users__title">Користувачі</h1>
      <ul className="users__list">
        {usersList?.map((i, idx) => ( <UsersItem key={i?.user_id || idx} data={i} idx={idx} onUserChange={onUserChange} /> ))}
      </ul>
      <Modal showModal={showModal} setShowModal={setShowModal}>
        {compareStrings(modalType, 'UserEditPswForm') && ( <UserEditPswForm data={selectedUserData} closeModal={setModal} /> )}
        {compareStrings(modalType, 'UserEditNameForm') && ( <UserEditNameForm data={selectedUserData} closeModal={setModal} /> )}
        {compareStrings(modalType, 'UserDeleteModal') && ( <SubmitMsg text={submitMsgText} handleCancel={() => setModal()} handleSubmit={onUserDelete} />
        )}
      </Modal>
    </>
  );
};

export default UsersList;
